import { Arrow } from '@anm/styles/helpers';
import noop from 'lodash/fp/noop';
import React, { forwardRef, PropsWithChildren, Ref } from 'react';

import BreadcrumbItem, { BreadcrumbItemProps } from './BreadcrumbItem';
import { BreadcrumbWrapper, ItemWrapper } from './Wrapper';

export type BreadcrumbsProps<T> = {
  data: T[];
  freeSpace?: number;
  isPending?: boolean;
  renderItem: <P extends T & BreadcrumbItemProps>(props: P) => JSX.Element;
  onClick?: (item: T) => void;
};

const Breadcrumbs = <T extends BreadcrumbItemProps>(
  {
    data,
    isPending,
    renderItem = item => <BreadcrumbItem {...item} />,
    onClick = noop,
    freeSpace
  }: PropsWithChildren<BreadcrumbsProps<T>>,
  ref: Ref<HTMLDivElement>
) => {
  return (
    <BreadcrumbWrapper ref={ref}>
      {data.map((item, index) => {
        const isFirst = index === 0;
        const isLast = data.length - 1 === index;

        const handler = () => !isLast && !isPending && onClick(item);

        return (
          <ItemWrapper key={item.id} isPending={isPending} onClick={handler}>
            {renderItem({ isFirst, isLast, ...item, freeSpace })}
            {!isLast && <Arrow />}
          </ItemWrapper>
        );
      })}
    </BreadcrumbWrapper>
  );
};

export default forwardRef(Breadcrumbs);
